import { HeldEmailConfirmButtons } from "./HeldEmailConfirmButtons";
import { SystemEmailModeConfirmModel } from "./systemEmailModeConfirmModel";

export function SystemEmailModeConfirmActions({
  model,
}: {
  model: SystemEmailModeConfirmModel;
}) {
  return (
    <HeldEmailConfirmButtons
      actionLabel="Confirm change"
      cancelLabel="Cancel"
      color={model.mode === "off" ? "red" : "blue"}
      loading={model.loading}
      onClose={model.onClose}
      onConfirm={model.onConfirm}
    />
  );
}
